
export default function VictoriaZoning() {
  const zones = [
    {
      zone: 'R1 - Single Family',
      allowed: true,
      conditions: 'Principal residence only. Owner must occupy property minimum 180 days/year.',
      maxGuests: '4 guests'
    },
    {
      zone: 'R2 - Two Family',
      allowed: true,
      conditions: 'STR permitted in owner-occupied unit. Secondary suite may be rented if owner lives on-site.',
      maxGuests: '4 guests per unit'
    },
    {
      zone: 'R3 - Multiple Dwelling',
      allowed: true,
      conditions: 'Condo/apartment STR allowed with strata approval and principal residence requirement.',
      maxGuests: '4 guests'
    },
    {
      zone: 'C1 - Commercial',
      allowed: false,
      conditions: 'STR not permitted in commercial zones. Traditional hotel/motel licensing applies.',
      maxGuests: 'N/A'
    },
    {
      zone: 'Heritage Areas',
      allowed: true,
      conditions: 'Additional heritage permit may be required. Character-defining elements must be preserved.',
      maxGuests: '4 guests'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Zoning Regulations
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Where STRs Are Permitted in Victoria
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Victoria&apos;s STR regulations vary by zoning district. Understanding your property&apos;s zone is essential for compliance.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full bg-[#F8F8F8] rounded-2xl overflow-hidden">
            <thead>
              <tr className="bg-[#505A5A] text-white">
                <th className="px-6 py-4 text-left font-semibold">Zone</th>
                <th className="px-6 py-4 text-center font-semibold">STR Allowed</th>
                <th className="px-6 py-4 text-left font-semibold">Conditions</th>
                <th className="px-6 py-4 text-center font-semibold">Max Guests</th>
              </tr>
            </thead>
            <tbody>
              {zones.map((zone, index) => (
                <tr
                  key={zone.zone}
                  className={`border-b border-[#E5E5E5] ${index % 2 === 0 ? 'bg-white' : 'bg-[#F8F8F8]'}`}
                >
                  <td className="px-6 py-5 font-medium text-[#505A5A]">{zone.zone}</td>
                  <td className="px-6 py-5 text-center">
                    {zone.allowed ? (
                      <span className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium">
                        <i className="ri-check-line"></i> Yes
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm font-medium">
                        <i className="ri-close-line"></i> No
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-5 text-[#505A5A]/70">{zone.conditions}</td>
                  <td className="px-6 py-5 text-center text-[#505A5A] font-medium">{zone.maxGuests}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <div className="bg-[#F8F8F8] rounded-2xl p-8">
            <div className="w-12 h-12 bg-[#882629]/10 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-map-2-line text-2xl text-[#882629]"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#505A5A] mb-3">Downtown Core</h3>
            <p className="text-[#505A5A]/70 leading-relaxed">
              The downtown area has high tourism demand but strict enforcement. Many heritage buildings have additional requirements. Strata corporations in this area often have their own STR restrictions.
            </p>
          </div>
          <div className="bg-[#F8F8F8] rounded-2xl p-8">
            <div className="w-12 h-12 bg-[#882629]/10 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-home-smile-line text-2xl text-[#882629]"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#505A5A] mb-3">Residential Neighborhoods</h3>
            <p className="text-[#505A5A]/70 leading-relaxed">
              Areas like James Bay, Fairfield, and Oak Bay (separate municipality) have strong STR demand from tourists visiting nearby attractions. Principal residence rules apply throughout.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
